module.exports = {
    expired_1: "লিঙ্কের মেয়াদ শেষ",
    limit_time: "সীমিত সময়ের অফার ",
    participate: "এখনই রিভিউ ইভেন্টে অংশগ্রহণ করুন এবং আপনার এক্সক্লুসিভ পুরস্কার দাবি করুন!",
    exclusive: "এক্সক্লুসিভ",
    reward: "পুরস্কার",
    token: "টোকেন",
    vip: "দিন VIP",
    after_completing: "রিভিউ এবং স্ক্রিনশট যাচাইকরণ সম্পূর্ণ করার পর, আপনি পাবেন",
    step_1: "<strong style='color: #000000'>নিচের বাটনে ক্লিক করুন</strong> অ্যাপ স্টোরে যেতে এবং <strong style='color: #000000'>৫-স্টার রিভিউ দিন।</strong>",
    step_2: "রিভিউ সম্পূর্ণ করার পর, অনুগ্রহ করে আপনার রিভিউ কন্টেন্টের <strong style='color: #000000'>একটি স্ক্রিনশট নিন।</strong>",
    step_3: "<strong style='color: #000000'>স্ক্রিনশট আপলোড করুন</strong> নিচে এবং আপনার ইন-অ্যাপ ID জমা দিন আপনার পুরস্কার পেতে।",
    click_to: "1. ক্লিক করে যান ",
    upload: "2. রিভিউ স্ক্রিনশট আপলোড করুন",
    app_store: "অ্যাপ স্টোর",
    google_play: "গুগল প্লে",
    go_to: "যান ",
    example: "স্ক্রিনশট উদাহরণ",
    upload_screenshot: "স্ক্রিনশট আপলোড করুন",
    claim: "পুরস্কার দাবি করুন",
    verification_inprogress: "আপনার আপলোডের জন্য ধন্যবাদ। আপনার স্ক্রিনশটটি যত তাড়াতাড়ি সম্ভব পর্যালোচনা করা হচ্ছে। অনুগ্রহ করে ধৈর্য্য ধরুন।",
    verification_success: "অভিনন্দন! <br/><br/> আপনি সফলভাবে আপনার পুরস্কার দাবি করেছেন। পুরস্কারটি আপনার অ্যাকাউন্টে <strong>২৪ ঘন্টার মধ্যে</strong> জমা করা হবে। অনুগ্রহ করে অনুসরণ করুন। <br/><br/> আপনার কোন প্রশ্ন থাকলে, গ্রাহক সেবার সাথে যোগাযোগ করতে নির্দ্বিধায়।",
    verification_failed: "রিভিউের স্ক্রিনশটটি নিম্নলিখিত শর্তগুলি পূরণ করতে হবে: <br/><br/> <div style='margin-left: 6px'> ১. রেটিংটি ৫ স্টার হতে হবে এবং বিষয়বস্তু ইতিবাচক হতে হবে। <br/><br/> ২. রিভিউটি <strong> Apple App Store বা Google Play Store</strong>-তে করা হতে হবে। <br/><br/> ৩. স্ক্রিনশটটিতে রিভিউের বিষয়বস্তু সম্পূর্ণরূপে প্রদর্শন করতে হবে, যাতে <strong>অ্যাভাটার, ব্যবহারকারীর নাম এবং রিভিউের পাঠ্য</strong> অন্তর্ভুক্ত থাকে।</div>",
    reupload: "পুনরায় আপলোড করুন"
}